{
	"title": "Проекти",
	"table": {
		"reference": "Референция",
		"quantity": "Общо количество",
		"savings": "Общо въглеродни редукции",
		"fetchError": "Не можа да се извлекат проектите"
	},
	"showProjectsHistoryTitle": "Покажи историята на проектите",
	"noProjects": {
		"createDeclaration": "Създайте първата си декларация",
		"description": "Можете да създавате декларации за един или повече материали като натиснете „Създай декларация“."
	}
}
